import { isDate, mapValues } from 'lodash-es'

export function useQueryParams<T extends object>(source: MaybeRefOrGetter<T>) {
  return computed(() =>
    sortKeys(removeEmpty(mapValues(toValue(source), toQueryValue))),
  )
}

function toQueryValue(value: unknown) {
  return isDate(value) ? toServerDate(value) : value
}
